import { z } from "zod";

export const BlacklistTypeSchema = z.enum(["IP", "EMAIL", "PHONE"]);

export const BlacklistItemSchema = z.object({
  type: BlacklistTypeSchema,
  value: z.string().min(1),
  reason: z.string().optional(),
  isActive: z.boolean().default(true),
});

export const FraudSettingsSchema = z.object({
  velocityEnabled: z.boolean().default(false),
  velocityLimit: z.number().int().min(1).default(1),
  velocityWindowHours: z.number().int().min(1).default(1),
  maxItemsEnabled: z.boolean().default(false),
  maxItemsPerOrder: z.number().int().min(1).default(20),
});

export const FraudConfigResponseSchema = z.object({
  settings: FraudSettingsSchema,
  blacklists: z.array(BlacklistItemSchema),
});

export const UpdateFraudConfigRequestSchema = z.object({
  settings: FraudSettingsSchema.optional(),
  blacklists: z.array(BlacklistItemSchema).optional(),
});

export type FraudSettings = z.infer<typeof FraudSettingsSchema>;
export type BlacklistItem = z.infer<typeof BlacklistItemSchema>;
export type FraudConfigResponse = z.infer<typeof FraudConfigResponseSchema>;
export type UpdateFraudConfigRequest = z.infer<
  typeof UpdateFraudConfigRequestSchema
>;
